import PropTypes from 'prop-types';
// @mui
import Button from '@mui/material/Button';
import MenuItem from '@mui/material/MenuItem';
import TableRow from '@mui/material/TableRow';
import Checkbox from '@mui/material/Checkbox';
import TableCell from '@mui/material/TableCell';
import IconButton from '@mui/material/IconButton';
// hooks
import { useBoolean } from 'src/hooks/use-boolean';
// components
import Iconify from 'src/components/iconify';
import CustomPopover, { usePopover } from 'src/components/custom-popover';
import { ConfirmDialog } from 'src/components/custom-dialog';
import { dateFormatter, formatDate } from 'src/services/fetching';
//

// ----------------------------------------------------------------------

export default function UserTableRow({ row, selected, onEditRow, onSelectRow, onDeleteRow, projectId }) {
    const {
        code,
        description,
        quantity,
        unit,
        unit_price,
        hourly_rate,
        budgeted_amount,
        budgeted_hours,
        planned_labor_cost,
        planned_material_cost,
        planned_equipment_cost,
        planned_subcontractor_cost,
        mark_ups,
        priority,
        planned_start_date,
        planned_finish_date,
        duration,
        created_at,
        updated_at,
    } = row;
    console.log(row, '=======================')

    const confirm = useBoolean();


    const popover = usePopover();

    return (
        <>
            <TableRow hover selected={ selected }>
                <TableCell padding="checkbox">
                    <Checkbox checked={ selected } onClick={ onSelectRow } />
                </TableCell>

                <TableCell sx={ { whiteSpace: 'nowrap' } }>{ code }</TableCell>
                <TableCell sx={ { whiteSpace: 'nowrap' } }>{ description }</TableCell>
                <TableCell sx={ { whiteSpace: 'nowrap' } }>{ quantity }</TableCell>
                <TableCell sx={ { whiteSpace: 'nowrap' } }>{ hourly_rate }</TableCell>
                <TableCell sx={ { whiteSpace: 'nowrap' } }>{ planned_labor_cost }</TableCell>
                <TableCell sx={ { whiteSpace: 'nowrap' } }>{ planned_material_cost }</TableCell>
                <TableCell sx={ { whiteSpace: 'nowrap' } }>{ planned_equipment_cost }</TableCell>
                <TableCell sx={ { whiteSpace: 'nowrap' } }>{ planned_subcontractor_cost }</TableCell>
                <TableCell sx={ { whiteSpace: 'nowrap' } }>{ }</TableCell>
                <TableCell sx={ { whiteSpace: 'nowrap' } }>{ unit_price }</TableCell>
                <TableCell sx={ { whiteSpace: 'nowrap' } }>{ mark_ups }</TableCell>
                <TableCell sx={ { whiteSpace: 'nowrap' } }>{ dateFormatter(planned_start_date) }</TableCell>
                <TableCell sx={ { whiteSpace: 'nowrap' } }>{ dateFormatter(planned_finish_date) }</TableCell>
                <TableCell sx={ { whiteSpace: 'nowrap' } }>{ duration }</TableCell>

                <TableCell align="right" sx={ { px: 1, whiteSpace: 'nowrap' } }>
                    <IconButton color={ popover.open ? 'inherit' : 'default' } onClick={ popover.onOpen }>
                        <Iconify icon="eva:more-vertical-fill" />
                    </IconButton>
                </TableCell>
            </TableRow>

            <CustomPopover
                open={ popover.open }
                onClose={ popover.onClose }
                arrow="right-top"
                sx={ { width: 140 } }
            >
                <MenuItem
                    onClick={ () => {
                        confirm.onTrue();
                        popover.onClose();
                    } }
                    sx={ { color: 'error.main' } }
                >
                    <Iconify icon="solar:trash-bin-trash-bold" />
                    Delete
                </MenuItem>

                <MenuItem
                    onClick={ () => {
                        onEditRow();
                        popover.onClose();
                    } }
                >
                    <Iconify icon="solar:pen-bold" />
                    Edit
                </MenuItem>
            </CustomPopover>

            <ConfirmDialog
                open={ confirm.value }
                onClose={ confirm.onFalse }
                title="Delete"
                content="Are you sure want to delete?"
                action={
                    <Button variant="contained" color="error" onClick={ onDeleteRow }>
                        Delete
                    </Button>
                }
            />
        </>
    );
}

UserTableRow.propTypes = {
    onDeleteRow: PropTypes.func,
    onEditRow: PropTypes.func,
    onSelectRow: PropTypes.func,
    row: PropTypes.object,
    selected: PropTypes.bool,
};
